import React, { useState, useEffect, useContext } from "react";
import { ModalBody, Modal, Spinner } from "react-bootstrap";
import { getApiService } from "../services/ApiService";
import { GetPayLoad } from "../services/PayLoadStorage";
import { LanguageContext } from "../contexts/LanguageContext";
import '../assets/css/Modal.css';

const ExpiryUpdateModal = ({ accountName, accountNo, vaultId, accountType, expiryDate, setExpiryModal, sendDataToParent }) => {

    const Payload = GetPayLoad('PayLoad');
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const headers = {
        "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
        "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
        "X-Hps-Region": Payload?.region
    };
    const [isDisabled, setDisabled] = useState(false);
    const handleCancel = () => setExpiryModal(false);
    const [isLoading, setLoading] = useState(false);
    const expiry_value = expiryDate.split('/');
    const [expiryMonth, setExpiryMonth] = useState(expiry_value[0]);
    const [expiryYear, setExpiryYear] = useState(expiry_value[1]);
    const [showError, setError] = useState(false);
    const { pageContent } = useContext(LanguageContext);
    const [overViewContent, setOverViewContent] = useState([]);
    const [genericContent, setGenericContent] = useState([]);

    const handleExpMonth = (event) => {
        setExpiryMonth(event.target.value);
    };
    const handleExpYear = (event) => {
        setExpiryYear(event.target.value);
    };
    const [errorMsg, setErrorMsg] = useState([]);

    useEffect(() => {
        if (pageContent?.overview) {
            setOverViewContent(pageContent.overview);
        }

        if (pageContent?.generic) {
            setGenericContent(pageContent.generic);
        }
    }, [pageContent]);

    const handleExpiry = (e) => {
        e.preventDefault();
        let exp_month = document.getElementById('expiration_month').value;
        let exp_year = document.getElementById('expiration_year').value;
        // Validate the input for expiration month and year
        const now = new Date();
        const currentYear = now.getFullYear() % 100; // Get last two digits of the year
        const currentMonth = now.getMonth() + 1; // Months are 0-indexed in JavaScript
        const month = parseInt(exp_month, 10);
        const year = parseInt(exp_year, 10);

        if (exp_month === '' || exp_year === '') {
            setErrorMsg(overViewContent?.overview_expiry_modal_month_year_error_msg);
            setError(true);
        } else if ((exp_month !== '' && exp_month.length > 2) || exp_year !== '' && exp_year.length > 2) {
            setErrorMsg(overViewContent?.overview_expiry_modal_more_than_digit_error_msg)
            setError(true);
        } else if ((exp_month !== '' && exp_month.length < 2) || exp_year !== '' && exp_year.length < 2) {
            setErrorMsg(overViewContent?.overview_expiry_modal_less_than_digit_error_msg)
            setError(true);
        } else if(year < currentYear || (year === currentYear && month < currentMonth)) {
            setErrorMsg(overViewContent?.overview_expiry_modal_past_date_error_msg);
            setError(true);
        } else if(month < 1 || month > 12) {
            setErrorMsg(overViewContent?.overview_expiry_modal_month_greater_or_less_than_error_msg);
            setError(true);
        }else {
            setErrorMsg("");
            setError(false);
            setDisabled(true);
            setLoading(true);
            const targetActivateAccountUrl = process.env.REACT_APP_API_ACTIVATE_ACCOUNT_ENDPOINT;
            getApiService(baseUrl, targetActivateAccountUrl, { cim: Payload?.cim, vault_id: vaultId, account_type: accountType, exp_month: exp_month, exp_year: exp_year, action: 'update' }, headers)
                .then((response) => {
                    setLoading(false);
                    if (response?.data?.statusCode !== 200) {
                        setDisabled(false);
                        sendDataToParent(genericContent?.service_post_error, 'error');
                    }else{
                        const result = response.data.data;
                        if (result) {
                            setExpiryModal(false);
                            sendDataToParent(overViewContent?.overview_expiry_modal_success_msg, 'success');
                        }
                    }
                })
                .catch(error => {
                    setLoading(false);
                    setDisabled(false);
                    sendDataToParent(genericContent?.service_post_error, 'error');
                });
        }
    }

    return (
        <div>
            <Modal.Header className={`billing-header d-xl-flex d-md-flex pb-4 ${Payload?.owning_carrier === 'Q5' ? 'mobile-close-btn' : ''}`} closeButton>
                <span tabIndex={0}>
                    <h4>{overViewContent?.overview_expiry_modal_title}</h4>
                </span>
            </Modal.Header>

            <ModalBody>
                <div tabIndex={0} className="d-flex align-items-center col-12 mb-3">
                    <div className="col-3">
                        <label for="Name" className="form-label mb-0">{overViewContent?.overview_expiry_modal_name_text}</label>
                    </div>
                    <div className="col-6">
                        <label className="expiry-modal-label mb-0">{accountName}</label>
                    </div>
                </div>
                <div tabIndex={0} className="d-flex align-items-center col-12 mb-3">
                    <div className="col-3">
                        <label for="CardNumber" className="form-label mb-0">{overViewContent?.overview_expiry_modal_card_no_text}</label>
                    </div>
                    <div className="col-6">
                       <label className="expiry-modal-label mb-0">{overViewContent?.overview_expiry_modal_card_no_star} {accountNo}</label>
                    </div>
                </div>
                <div className="d-flex align-items-center col-12 mb-3">
                    <div className="col-3">
                        <label for="ExpirationDate" className="form-label mb-0">{overViewContent?.overview_expiry_modal_exp_date_text}
                            <span className="text-danger">*</span></label>
                    </div>
                    <div className="d-flex col-6 align-items-center">
                        <input type="number" name="cc_exp_mm" id="expiration_month" className={`form-control col-5 ${showError ? 'is-invalid' : ''}`} maxlength="2" aria-label="ExpiryMonth" value={expiryMonth} onChange={handleExpMonth} style={{ width: '100px' }} />
                        <input type="number" className={`form-control col-5 ms-3 ${showError ? 'is-invalid' : ''}`} id="expiration_year" aria-label="ExpiryYear" required="" value={expiryYear} onChange={handleExpYear} style={{ width: '100px' }} />
                    </div>
                </div>
                <div className="d-flex col-6">
                    {showError && (
                        <div className="d-flex col-6 invalid-feedback" style={{ display: 'block' }}>{errorMsg}</div>
                    )}
                </div>
                <div className="col-12 mb-3">
                    {/* Responsive button order for Q5 carrier */}
                    {Payload?.owning_carrier === 'Q5' ? (
                        <>
                            {/* Mobile/Tablet: Expiry (Update) top, Cancel bottom */}
                            <div className="q5-switch-mobile-btns d-block d-lg-none">
                                <input
                                    type="submit"
                                    aria-label="submit"
                                    className="me-3 btn btn-secondary btn-lg mt-4 col-5 expiryupdatebtn"
                                    value={overViewContent?.overview_expiry_modal_update_btn_text}
                                    required=""
                                    style={{ fontSize: '15px' }}
                                    onClick={handleExpiry}
                                    disabled={isDisabled}
                                />
                                
                                <input
                                    type="button"
                                    aria-label="Cancel"
                                    className="btn btn-outline-secondary btn-lg mt-4 col-5 expirycancelbtn"
                                    value={overViewContent?.overview_expiry_modal_cancel_btn_text}
                                    data-bs-toggle="modal"
                                    href="#removeaccount"
                                    style={{ fontSize: '15px' }}
                                    onClick={handleCancel}
                                />
                            </div>
                            {/* Large screens: Cancel first, Expiry (Update) second */}
                            <div className="q5-switch-desktop-btns d-none d-lg-flex">
                                <input
                                    type="button"
                                    aria-label="Cancel"
                                    className="me-3 btn btn-outline-secondary btn-lg mt-4 col-5 expirycancelbtn"
                                    value={overViewContent?.overview_expiry_modal_cancel_btn_text}
                                    data-bs-toggle="modal"
                                    href="#removeaccount"
                                    style={{ fontSize: '15px', width: '35%' }}
                                    onClick={handleCancel}
                                />
                                <input
                                    type="submit"
                                    aria-label="submit"
                                    className="btn btn-secondary btn-lg mt-4 col-5 expiryupdatebtn"
                                    value={overViewContent?.overview_expiry_modal_update_btn_text}
                                    required=""
                                    style={{ fontSize: '15px', width: '35%' }}
                                    onClick={handleExpiry}
                                    disabled={isDisabled}
                                />
                            </div>
                        </>
                    ) : (
                        <>
                            <input type="button" aria-label="Canel"
                                className="me-3 btn btn-outline-secondary btn-lg mt-4 col-5 expirycancelbtn" value={overViewContent?.overview_expiry_modal_cancel_btn_text}
                                data-bs-toggle="modal" href="#removeaccount" style={{ fontSize: '15px', width: '35%' }} onClick={handleCancel} />
                            <input type="submit" aria-label="submit" className="btn btn-secondary btn-lg mt-4 col-5 expiryupdatebtn"
                                value={overViewContent?.overview_expiry_modal_update_btn_text} required="" style={{ fontSize: '15px', width: '35%' }} onClick={handleExpiry} disabled={isDisabled} />
                        </>
                    )}
                    {isLoading && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '15px', margin: 'inherit', float: 'right', paddingTop: '15px' }}>
                            <Spinner animation="border" role="status" ></Spinner>
                            <div style={{ fontSize: "12px" }}>{genericContent?.loading_message}</div>
                        </div>
                    )}
                </div>
            </ModalBody>
        </div>
    )
}

export default ExpiryUpdateModal;